module.exports = __webpack_public_path__ + "3-o1.jpg?68ebe13148056347d19c6f156770aef8";


//////////////////
// WEBPACK FOOTER
// ./src/assets/quiz/questions/3-o1.jpg
// module id = 652
// module chunks = 0